import { useState, useEffect } from "react";
import axios from "axios";
import adminApi from "@/lib/adminApi";
import { toast } from "sonner";
import { Save, Headphones } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const FIELDS = [
  { key: "spotify_monthly_listeners", label: "Oyentes mensuales" },
  { key: "spotify_monthly_streams", label: "Reproducciones mensuales" },
  { key: "spotify_total_streams", label: "Streams totales" },
  { key: "spotify_followers", label: "Seguidores en Spotify" },
];

export default function MediaKitMusicStatsTab() {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/media-kit/music`).then((res) => setForm(res.data)).catch(() => {});
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = Object.fromEntries(FIELDS.map((f) => [f.key, parseInt(form[f.key], 10) || 0]));
      await adminApi.put(`/media-kit/music`, payload);
      toast.success("Cifras de Spotify guardadas");
    } catch (error) {
      toast.error("Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm max-w-xl">
      <h2 className="text-xl font-bold text-black mb-1 flex items-center gap-2">
        <Headphones className="text-[#1DB954]" /> Cifras de Spotify
      </h2>
      <p className="text-sm text-gray-500 mb-4">Cópialas de Spotify for Artists. Se muestran en el Media Kit de Música.</p>
      <form onSubmit={handleSave} className="space-y-4">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <label className="block text-sm text-gray-600 mb-1 font-medium">{f.label}</label>
            <Input
              type="number"
              min="0"
              inputMode="numeric"
              value={form[f.key] ?? ""}
              onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
              className="bg-gray-50 border-gray-200 text-black"
              data-testid={`music-stat-input-${f.key}`}
            />
          </div>
        ))}
        <Button type="submit" disabled={saving} className="bg-[#E91E8C] hover:bg-[#E91E8C]/90 text-white w-full" data-testid="music-stats-save-btn">
          <Save size={16} className="mr-2" /> {saving ? "Guardando..." : "Guardar"}
        </Button>
      </form>
    </div>
  );
}
